export default "__VITE_ASSET__COzD7TJ9__ 720w";